import ActionBtn from '@/components/ActionBtn'
import TechTextFields from './TechTextFields'
import TechFiles from './TechFiles'

const TechDataRow = ({ tech, formHandler, isLoading, removeTechnology, updateTechnology }) => {


  return (
    <div className="technology-item-card col-lg-6 mb-2">
      <div className="technology-item-card-content">

        <ActionBtn
          icon="mdi:delete"
          className="remove-tech-btn pointer"
          onApply={() => removeTechnology(tech.id)} />

        <div className="row">
          <div className="col-12">
            <TechTextFields tech={tech} formHandler={formHandler} isLoading={isLoading} updateTechnology={updateTechnology} />
          </div>

          <div className="col-12">
            <TechFiles tech={tech} updateTechnology={updateTechnology} />
          </div>

        </div>
      </div>
    </div>
  )
}

export default TechDataRow